import React, { useCallback, useEffect } from "react";
import CenterLolumnLayout from "../../layout/screen";
import './style.scss'
import PageFooter from "../../components/page-footer";
import { Link } from "react-router-dom";
import { getMapRoute } from "../../routes";
// import Dyplom from "../../components/dyplom";
import { useResetBackground } from "../../layout/background";
import useReset from '../../modules/user/hooks/use-reset';

export default function EndPage() {

    const resetBackground = useResetBackground();
    useEffect(() => {
        resetBackground();
    }, [resetBackground])

    const reset = useReset();
    const onResetClicked = useCallback((e: React.MouseEvent) => {
        reset();
    }, [reset])

    return (
        <CenterLolumnLayout footer={PageFooter()}>
            <div className="end-page">
                <h1>
                    Gratulacje!<br/>Ukończyłeś wszystkie zadania.
                </h1>
                <nav>
                    <div className="buttons">
                        <Link className="button-big" to={getMapRoute()}>wróć do mapy</Link>
                        <a onClick={onResetClicked} className="button-big">zacznij od nowa</a>
                    </div>
                </nav>
            </div>
        </CenterLolumnLayout >
    )
}
